define(
    '../../widgets/select-specific/main',[
        'jquery',
        'utils/bind-manager',
        'utils/cookies'
    ],
    function ($, bindMng, cookies) {

       return function () {

            var selectSpecific = function() {
                function selectSpecific (ss) {
                    this.ss = ss;
                    this.itemsList = ss.children('.select--specific__item');
                    this.selectedValue = false;

                    if (this.itemsList.length > 1) {
                        this.initSelect();
                        this.activate();
                        this.bind();
                    }
                }

                function setCookieIfAvailable(option) {
                    var cookieKey = option.data('cookie-key');
                    if (cookieKey) {
                        cookies.set(cookieKey, option.data('cookie-value'), 365, option.data('cookie-path'));
                        console.log('cookie specified', cookieKey);
                    } 
                    else
                        console.log('cookie not specified')
                }

                selectSpecific.prototype.initSelect = function() {
                    var _this = this;

                    this.prepareDefaultSelectedOption();

                    this.select = $('<select>').attr('name', this.ss.data('select-name'));
                    this.select.appendTo(this.ss);

                    this.itemsList.each(function() {
                        var iThis = $(this);

                            option = $('<option>')
                                .html(iThis.data('option'))
                                .attr('value', iThis.data('value'))
                                .appendTo(_this.select);

                            if (iThis.data('selected')) {
                                option.attr('selected', 'selected');
                                this.selectedValue = iThis.data('value');
                            }
                    });
                };

                selectSpecific.prototype.prepareDefaultSelectedOption = function() {
                    if ( !this.itemsList.filter('[data-selected]').length ) {
                        this.itemsList.first().attr('data-selected', 'selected');
                    }
                };

                selectSpecific.prototype.changeValue = function() {
                    var newValue = this.select.find('option:selected').attr('value');
                    if (newValue !== this.selectedValue) {
                        this.selectedValue = newValue;
                        this.itemsList.removeAttr('data-selected').filter('[data-value="'+ this.selectedValue +'"]').attr('data-selected', 'selected');    
                    }
                };

                selectSpecific.prototype.navigateSelectedPage = function() {
                    var currentItem = this.itemsList.filter('[data-value="'+ this.selectedValue +'"]'),
                        children = currentItem.children();

                    if (children.length === 1 && children.is('a')) {
                        setCookieIfAvailable(children.first());
                        window.location.href = children.first().attr('href');
                    }

                };

                selectSpecific.prototype.bind = function() {
                    this.bindSelect();
                };

                selectSpecific.prototype.bindSelect = function() {
                    var _this = this;
                    this.select.on('change', function(e) {
                        _this.changeValue();
                        _this.navigateSelectedPage();
                    });
                }

                selectSpecific.prototype.activate = function() {
                    this.ss.addClass('select--specific--activated');
                };

                selectSpecific.prototype.deactivate = function() {
                  this.ss.removeClass('select--specific--activated');  
                };

                selectSpecific.prototype.destroy = function() {
                     this.destroyList.resolve();
                };

                return selectSpecific;
            }();

            $('.select--specific').each(function(i) {
                var ss = new selectSpecific($(this));
            });

            return selectSpecific;
        };
    }
);


/*        return function () {
            bindMng.add('.select select', 'focus', function () {
                $(this).parent().addClass('select--focused');
            });

            bindMng.add('.select select', 'blur', function () {
                $(this).parent().removeClass('select--focused');
            });
        };
    }
);*/;
